'use strict';
if (!window.NA) { window.NA = {}; }

/**
 * Usage:
 * <div na-modal-target='the-modal'>Click Here to open the modal!</div>
 * <div class='na-modal-container' id='the-modal' na-modal-target>
 *  <div class="na-modal-content'>
 *    Here's a modal.
 *    <button na-modal-close>Click here to close.</button>
 *  </div>
 * <div>
 * 
 * Additional Options:
 * * na-disable-ezclose: This attribute on a modal target will disable Esc and clicking-outside to close the modal.
 * 
 * TODO: The container is mostly infrastructure.  We should create it with jquery rather 
 * than requiring it in the markup 
 */
window.NA.Modal = (function($) {
  // Close the target modal
  function close(target) {
    var $target = $(target);
    $(document.body).removeClass('na-modal-is-open');
    $(document).off('.closeModal');
    $(window).off('.modalNoScroll');

    $target.removeClass('na-modal--open');
    if ($target.attr('id') == "externalModal") $target.remove();
    $target.trigger('na-modal-closed');
  }

  /**
   * Close the modal using an "easy" method like Esc or clicking outside the modal, rather
   * than an explicit close button.  Can be disabled with attribute na-disable-ezclose on 
   * the modal element. 
   */  
  function ezClose(target) {
    var $target = $(target);

    if (!$target.is('[na-disable-ezclose]')) {
      close($target);
    }
  }

  function init() {
    // Clicks on na-modal-triggers open the targeted modal
    $(document.body).on('click', '[na-modal-trigger]', function(e){
      e.preventDefault();
      triggerModal(this.getAttribute('na-modal-trigger'));
    });

    /* Clicks outside of the modal close it.  This works because the [na-modal-target]
     * attribute is only present on the container/overlay, so click events on elements
     * within the modal won't pass the [na-modal-target] attribute test, but clicks on
     * the overlay element will */
    $(document.body).on('click', '[na-modal-target]', function(e){
      if (e.target.attributes['na-modal-target'])
        ezClose(e.target);
    });

    // Clicks on close buttons close their parent modal
    $(document.body).on('click', '[na-modal-close]', function(e){
      e.preventDefault();
      closeParent(e.target);
    })
  }
  
  function closeParent(target) {
    var $popup = $(target).closest('[na-modal-target]');
    close($popup);
  }

  /**
   * Keypress event handler.  Detects Esc-key presses, then closes any open modals
   */  
  function closeOnEsc(ev, $target) {
    if (ev.keyCode == 27) {
      ev.preventDefault();
      ezClose($target);
    }
  }

  function triggerModal(target) {
    // Close existing modals
    if (document.querySelector('.na-modal-container.na-modal--open'))
      close(document.querySelector('.na-modal-container.na-modal--open'));

    var $target = (target instanceof $) ? target : $('#' + target);
    
    if (!$target.length) { return; }
    
    $(document.body).addClass('na-modal-is-open');
    $target.addClass('na-modal--open');
    
    $(document).on('keydown.closeModal', function(ev) { closeOnEsc(ev, $target); })
    
    // Disable scrolling.  We're not using overflow:hidden style because it can shift the window
    // contents as the vertical scrollbar disappears.
    var currentScrolltop = $(window).scrollTop();
    $(window).on('scroll.modalNoScroll', function(ev) { $(window).scrollTop(currentScrolltop); return false; })
  }

  $(init);
  return { 
    triggerModal: triggerModal, 
    closeParent: closeParent 
  };
})(jQuery);